import messages from "./messages.i18n";
export const getReportTypesText = (intl, billingPeriod = "annually") => [
    {
        id: "basic",
        title: intl.formatMessage(messages.basicPlanTitle),
        subtitle: intl.formatMessage(messages.basicPlanSubtitleGeminiMonthlyReports),
        priceValue: billingPeriod === "monthly"
            ? intl.formatMessage(messages.basicPlanPriceValueTwentyFiveDollars)
            : intl.formatMessage(messages.basicPlanPriceValueTwentyOneTwentyFive),
        priceInlineLabel: intl.formatMessage(messages.basicPlanPriceInlinePerReportPerMonth),
        priceSubLabel: billingPeriod === "monthly"
            ? intl.formatMessage(messages.basicPlanPriceSubLabelBilledMonthly)
            : intl.formatMessage(messages.basicPlanPriceSubLabelBilledAnnually),
        buttonLabel: intl.formatMessage(messages.basicPlanPrimaryActionGetBasicReports),
        featuresTitle: intl.formatMessage(messages.basicPlanFeaturesSectionTitle),
        features: [
            intl.formatMessage(messages.basicPlanFeatureFirstReportFreeForTwoMonths),
            intl.formatMessage(messages.basicPlanFeatureGeminiOnlyVisibilityTracking),
            intl.formatMessage(messages.basicPlanFeatureMonthlyReports),
            intl.formatMessage(messages.basicPlanFeatureCompetitorAnalysis),
        ],
        highlightedFeatureIndexes: [0],
        modelLabels: ["Gemini"],
        billingOptions: {
            annuallyLabel: intl.formatMessage(messages.basicPlanBillingOptionAnnually),
            discountLabel: intl.formatMessage(messages.basicPlanBillingOptionDiscountFifteenPercentOff),
            monthlyLabel: intl.formatMessage(messages.basicPlanBillingOptionMonthly),
        },
    },
    {
        id: "premium",
        title: intl.formatMessage(messages.premiumPlanTitle),
        subtitle: intl.formatMessage(messages.premiumPlanSubtitleAllModelsMonthlyReportsAndCustomTopics),
        priceValue: billingPeriod === "monthly"
            ? intl.formatMessage(messages.premiumPlanPriceValueOneHundredDollars)
            : intl.formatMessage(messages.premiumPlanPriceValueEightyFiveDollars),
        priceInlineLabel: intl.formatMessage(messages.premiumPlanPriceInlinePerReportPerMonth),
        priceSubLabel: billingPeriod === "monthly"
            ? intl.formatMessage(messages.premiumPlanPriceSubLabelBilledMonthly)
            : intl.formatMessage(messages.premiumPlanPriceSubLabelBilledAnnually),
        buttonLabel: intl.formatMessage(messages.premiumPlanPrimaryActionGetPremiumReports),
        featuresTitle: intl.formatMessage(messages.premiumPlanFeaturesSectionTitle),
        features: [
            intl.formatMessage(messages.premiumPlanFeatureAllAiModels),
            intl.formatMessage(messages.premiumPlanFeatureCustomizableTopics),
            intl.formatMessage(messages.premiumPlanFeatureMonthlyReports),
            intl.formatMessage(messages.premiumPlanFeatureDetailedCompetitorAnalysis),
        ],
        highlightedFeatureIndexes: [0],
        modelLabels: ["Gemini", "ChatGPT", "Claude", "Perplexity"],
        recommendedLabel: intl.formatMessage(messages.premiumPlanRecommendedLabel),
        billingOptions: {
            annuallyLabel: intl.formatMessage(messages.premiumPlanBillingOptionAnnually),
            discountLabel: intl.formatMessage(messages.premiumPlanBillingOptionDiscountFifteenPercentOff),
            monthlyLabel: intl.formatMessage(messages.premiumPlanBillingOptionMonthly),
        },
        isPrimaryAction: true,
    },
    {
        id: "enterprise",
        title: intl.formatMessage(messages.enterprisePlanTitle),
        subtitle: intl.formatMessage(messages.enterprisePlanSubtitleLargeOrganizationRollout),
        priceValue: intl.formatMessage(messages.enterprisePlanPriceValueContactSales),
        priceSubLabel: intl.formatMessage(messages.enterprisePlanPriceSubLabelTailoredToPortfolioSize),
        buttonLabel: intl.formatMessage(messages.enterprisePlanPrimaryActionGetInTouch),
        featuresTitle: intl.formatMessage(messages.enterprisePlanFeaturesSectionTitleIncludesEverythingInPremiumPlus),
        features: [
            intl.formatMessage(messages.enterprisePlanFeatureCommunityLevelBilling),
            intl.formatMessage(messages.enterprisePlanFeatureWhiteGloveImplementation),
            intl.formatMessage(messages.enterprisePlanFeaturePayByInvoice),
            intl.formatMessage(messages.enterprisePlanFeatureCustomReportFrequency),
        ],
        highlightedFeatureIndexes: [0],
        modelLabels: ["Gemini", "ChatGPT", "Claude", "Perplexity"],
    },
];
